import Heading from '../../components/Heading/Heading';
import NavBar from '../../components/NavBar/NavBar';
import 'react-data-table-component-extensions/dist/index.css';
import "react-datepicker/dist/react-datepicker.css";
import dayjs from 'dayjs';
import { promocodeUsage, revokePromocodeAPI } from '../../api/apiHandler';
import { useLocation, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Paginator } from "primereact/paginator";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import { exportToCSV } from "../Common/ExportToExcel";
import Swal from "sweetalert2";


export default function PromocodeDetails({ isLoader }) {
  const location = useLocation();
  const [promoData, setPromoData] = useState(location?.state);
  const navigate = useNavigate();
  const [promoUsage, setPromoUsage] = useState([])
  const [totalRows, setTotalRows] = useState(0);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [search, setSearch] = useState("");
  const [first, setFirst] = useState(0);
  const [sortColumn, setSortColumn] = useState("id");
  const [sortOrder, setSortOrder] = useState("ASC");

  const formatWalletType = (walletType) => {
    if (!walletType) return "";

    return walletType
      .split('_')                        
      .map(word => word.charAt(0).toUpperCase() + word.slice(1)) 
      .join(' ');                       
  };

  const fetchPromocodeUsage = async () => {
    let pageInfo = {
      filter: {
        promocode_id: promoData.id,
        search: search 
      },
      pagination: {
        page: page,
        limit: perPage,
        search: search,
        sortColumn: sortColumn,
        sortOrder: sortOrder,
        limit: 10
      }
    }
    const response = await promocodeUsage(pageInfo);
    
    if (response.data.code === "1") {
      setPromoUsage(response.data.orders);
      setTotalRows(response.data.totalPages);
      setPage(response.data.page)
    } else {
      setPromoUsage([]);
      setTotalRows(0);
      setPage(0);
    }
    console.log(response.data.orders)
  };

  const handleRevoke = async () => {
    Swal.fire({
      title: "Confirm Revocation",
      text: "Are you sure you want to revoke this promocode?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonText: "Cancel",
      confirmButtonText: "Yes, revoke it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await revokePromocodeAPI( promoData );
          if (response?.status === 200 || response?.data?.status === "SUCCESS") {
            Swal.fire("Revoked!", "Promocode revoked successfully.", "success");
            setPromoData(prev => ({
              ...prev,
              remaining_amount: 0.00
            }));
            fetchPromocodeUsage(); 
          } else {
            Swal.fire(
              "Error",
              response?.data?.message || "Failed to revoke promocode.",
              "error"
            );
          }
        } catch (error) {
          Swal.fire("Error", "Something went wrong while revoking.", "error");
        }
      }
    });
  };

  const label_text = () => {
    let text = ''
    let type = promoData.discount_type;
    if(type === 'BUY_X_MEAL_GET_Y_MEAL' || type === 'FREE_MEAL'){
        text = 'No of free meal'
    }else if(type === 'BUY_X_MEAL_GET_Y_PERCENTAGE' || type === 'PERCENTAGE'){
        text = 'Percentage'
    }else{
        text = 'Discount value'
    }
    return text
  }

  const columns = [
    {
      id: 2,
      name: "Order ID",
      label: "Order ID",
      selector: (row) => row.orderID,
      sortable: true,
      cellExport: (row) => row.orderID,
    },
    {
      id: 3,
      name: "Discount code",
      label: "discount_code",
      selector: (row) => row.discount_code,
      sortable: true,
      cellExport: (row) => row.discount_code,
    },
    {
      id: 4,
      name: "Discount type",
      label: "discount_type",
      selector: (row) => row.discount_type,
      sortable: true,
      cellExport: (row) => row.discount_type,
    },
    {
      id: 5,
      name: "Discounted amount",
      label: "discounted_amount",
      selector: (row) => row.discounted_amount,
      sortable: true,
      cellExport: (row) => row.discounted_amount,
    },
    {
      id: 6,
      name: "Sub total",
      label: "sub_total",
      selector: (row) => row.sub_total,
      sortable: true,
      cellExport: (row) => row.sub_total,
    },
    {
      id: 7,
      name: "Sub total after discount",
      label: "sub_total_after_discount",
      selector: (row) => row.sub_total_after_discount,
      sortable: true,
      cellExport: (row) => row?.sub_total_after_discount
    },
    {
      id: 8,
      name: "User Name",
      label: "user_name",
      selector: (row) => row.orderDetails?.[0]?.parent_name || "-",
      sortable: true,
      cellExport: (row) => row.orderDetails?.[0]?.parent_name || "-",
    },
    {
      id: 9,
      name: "Child Name",
      label: "child_name",
      selector: (row)=>row.orderDetails?.[0]?.child_name || "-",
      sortable: true,
      cellExport: (row) => row.orderDetails?.[0]?.child_name || "-",
    },
    {
      id: 10,
      name: "School Name",
      label: "school_name",
      selector: (row) => row.orderDetails?.[0]?.school_name || "-",
      sortable: true,
      cellExport: (row) => row.orderDetails?.[0]?.school_name || "-",
    },
    {
      id: 12,
      name: "City Name",
      label: "city_name",
      selector: (row) => row.orderDetails?.[0]?.city_name || "-",
      sortable: true,
      cellExport: (row) => row.orderDetails?.[0]?.city_name || "-",
    },
    {
      id: 13,
      name: "Order Created",
      label: "order_date",
      selector: (row) => row.created_at ? dayjs(row.created_at).format("DD MMM, YYYY hh:mm A") : "-",
      sortable: true,
      cellExport: (row) => row.created_a ? dayjs(row.created_at).format("DD MMM, YYYY hh:mm A") : "-",
    }

    // {
    //   id: 8,
    //   name: "Action",
    //   print: false,
    //   selector: (row) => (
    //     <div className="action-btn">
    //       <Link
    //         to="/promocode-usage-details"
    //         state={row}
    //         className="btn btn-raised bg-blue-grey waves-effect mr-1"
    //       >
    //         <i className="zmdi zmdi-eye"></i>
    //       </Link>
    //     </div>
    //   ),
    //   width: "150px",
    // },
  ];

  useEffect(() => {
    fetchPromocodeUsage();
  }, [search, page, perPage]);

  const onPageChange = (info) => {
    setPage(info.page + 1);
    setPerPage(info.rows);
    setFirst(info.first);
  };

  const onSort = (info) => {
    if (sortColumn == info.sortField) {
      setSortOrder(sortOrder == "DESC" ? "ASC" : "DESC");
    } else {
      setSortOrder("ASC");
      setSortColumn(info.sortField);
    }
  };
 
  const customSortIcon = (options) => {
    let icon;
    if (options.field === sortColumn) {
      icon =
        sortOrder === "DESC" ? (
          <ArrowDropDownIcon {...options.iconProps} />
        ) : (
          <ArrowDropUpIcon {...options.iconProps} />
        );
    } else {
      icon = <SwapVertIcon {...options.iconProps} />;
    }
    return icon;
  };

  const callExport = async () => {
    isLoader(true);
    const pageInfo = {
      filter: {
        promocode_id: promoData.id,
      },
      pagination: {
        page: page,
        limit: 100
      },
    };

    promocodeUsage(pageInfo).then(async(res) => {
      if (res.data.code == 1) {
        isLoader(false);
        setPromoUsage(res.data.orders);
        setTotalRows(res.data.totalPages);

        var data = [];
        res.data?.orders?.map((item) => {
          var colum = {
            "Order Id": item.id,
            "Discount Code": item.discount_code,
            "Discount Type": item.discount_type,
            "Discounted Amount": item.discounted_amount,
            "Sub total": item.sub_total,
            "Sub total after discount": item.sub_total_after_discount,
            "PromoCode Create Date": dayjs(promoData?.created_at)?.format('DD MMM, YYYY'),
            "Usage Remaining": promoData?.allow_multiple_uses == 1 ? promoData.usage_limit - promoData.usage_count : 0,
            "PromoCode Expiry Date": dayjs(promoData?.valid_to)?.format('DD MMM, YYYY'),
            "Date of Usage": dayjs(item?.orderDetails?.created_at)?.format('DD MMM, YYYY'),
            "School Board": "",
            "City": item.orderDetails[0]?.city_name,
            "School Name": item.orderDetails[0]?.school_name,
            "Parent Name": item.orderDetails[0]?.parent_name,
            "Grade": ""
          };
          data.push(colum);
        })
         exportToCSV(data, `promocode_usage_list ${Date().toString()}`);
      } else {
        isLoader(false);
        setTotalRows(0);
      }
    });
  }
  return (
    <>
      <NavBar />
      <section className="content home">
        <Heading title="Promocode Details" />
        <div className="container-fluid">
          <div className="row clearfix">
            <div className="col-lg-12 col-md-12">
              <div className="card">
                <div className="header">
                </div>
                <div className="bg-custom bg-profile  button-color-css">
                </div>
                <div className="body">
                  <div className="col-12 text-left">
                    <a onClick={() => navigate(-1)} className="btn btn-raised waves-effect waves-float waves-red text-left mr-2"><i className="zmdi zmdi-arrow-left" /></a>
                  </div>
                  <hr />
                  <div class="row">
                    <div class="col d-flex justify-content-center">
                      <h4 class="m-0"><b>Promocode Details</b></h4>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-md-6">
                      <div className="card-box text-left m-l-10">
                        <div className="p-20">
                          <div className="about-info-p">
                            <strong>Name</strong>
                            <br />
                            <p className="text-muted">{promoData?.name}</p>
                          </div>
                          <div className="about-info-p">
                            <strong>Unique Code</strong>
                            <br />
                            <p className="text-muted">{promoData?.unique_code}</p>
                          </div>
                          <div className="about-info-p">
                            <strong>Discount type</strong>
                            <br />
                            <p className="text-muted">{promoData?.discount_type}</p>
                          </div>
                          <div className="about-info-p">
                            <strong>Valid From</strong>
                            <br />
                            <p className="text-muted">{dayjs(promoData?.valid_from).format('DD MMM, YYYY')}</p>
                          </div>
                          <div className="about-info-p">
                            <strong>Eligible Promocode</strong>
                            <br />
                            <p className="text-muted">
                            {promoData?.school_board_array?.length > 0 ? (
                                promoData.school_board_array.map((board, index) => (
                                  <span key={index}>
                                    {board.school_board}
                                    <br />
                                  </span>
                                ))
                              ) : promoData?.schools_array?.length > 0 ? (
                                promoData.schools_array.map((school, index) => (
                                  <span key={index}>
                                    {school.school_name}
                                    <br />
                                  </span>
                                ))
                              ) : promoData?.parent_array?.length > 0 ? (
                                promoData.parent_array.map((parent, index) => (
                                  <span key={index}>
                                    {parent.parent_name}
                                    <br />
                                  </span>
                                ))
                              ) : promoData?.city_array?.length > 0 ? (
                                promoData?.city_array?.map((city,index) =>(
                                  <span key={index}>
                                    {city.city_name}
                                    <br />
                                  </span>
                                ))
                              ) : (
                                <span>-</span>
                              )
                            }
                            </p>
                          </div>                         
                          <div className="about-info-p">
                            <strong>Usage Limit</strong>
                            <br />
                            <p className="text-muted">{promoData?.usage_limit}</p>
                          </div>
                          <div className="about-info-p">
                            <strong>Allow multiple uses</strong>
                            <br />
                            <p className="text-muted">{promoData?.allow_multiple_uses}</p>
                          </div>
                          <div className="about-info-p">
                            <strong>No of required for meal base discount</strong>
                            <br />
                            <p className="text-muted">{promoData?.no_of_meals_for_meals_based_discount || 0}</p>
                          </div>
                          <div className="about-info-p">
                            <strong>Ceated by name</strong>
                            <br />
                            <p className="text-muted">{promoData?.created_school_details?.principal_name || ''}</p>
                          </div>
                          <div className="about-info-p">
                            <strong>Date Sent</strong>
                            <br />
                            <p className="text-muted">{dayjs(promoData?.created_at).format('DD MMM, YYYY')}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="card-box text-left m-l-10">
                        <div className="p-20">
                          <div className="about-info-p">
                            <strong>Minimum order value</strong>
                            <br />
                            <p className="text-muted">{promoData?.minimum_order_value}</p>
                          </div>
                          <div className="about-info-p">
                            <strong>Promotion sponsor code</strong>
                            <br />
                            <p className="text-muted">{promoData?.promotion_sponsor_code}</p>
                          </div>
                          <div className="about-info-p">
                            <strong>{ label_text() }</strong>
                            <br />
                            <p className="text-muted">{promoData?.discount_value}</p>
                          </div>
                          <div className="about-info-p">
                            <strong>Valid UpTo / Expire Date</strong>
                            <br />
                            <p className="text-muted">{dayjs(promoData?.valid_to).format('DD MMM, YYYY')}</p>
                          </div>
                          <div className="about-info-p">
                            <strong>Usage count</strong>
                            <br />
                            <p className="text-muted">{promoData?.usage_count}</p>
                          </div>
                          <div className="about-info-p">
                            <strong>Usage Status</strong>
                            <br />
                            <p className="text-muted">{formatWalletType(promoData?.status)}</p>
                          </div>
                          <div className="about-info-p">
                            <strong>Promo Code Type</strong>
                            <br />
                            <p className="text-muted">{formatWalletType(promoData?.promo_code_type)}</p>
                          </div>
                           <div className="about-info-p">
                            <strong>Promotion Type</strong>
                            <br />
                            <p className="text-muted">{promoData?.description}</p>
                          </div>
                          <div className="about-info-p">
                            <strong>Wallet Type</strong>
                            <br />
                            <p className="text-muted">{formatWalletType(promoData?.credit_source_wallet)}</p>
                          </div>
                          <div className="about-info-p">
                            <strong>Remaining Amount</strong>
                            <br />
                            <p className="text-muted">{promoData?.remaining_amount}</p>
                          </div>
                          {promoData?.remaining_amount > 0 ? (
                              <div>
                                <button
                                  className="btn btn-danger"
                                  onClick={handleRevoke}  
                                >
                                  Revoke
                                </button>
                              </div>
                            ) : (
                              ""
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="content home">
        <div className="container-fluid">
          <div className="row clearfix">
            <div className="col-lg-12 col-md-12 col-sm-12">
            <div class="row">
                <div class="col d-flex justify-content-left mb-3">
                  <h4 class="m-0"><b>Promocode Usage Details</b></h4>
                </div>
              </div>
              <div className="card">
                <div className="body">
                  <div className="d-flex justify-content-between mb-3">
                    {/* <input
                        placeholder="Filter Table"
                        onChange={(e) => {
                          if (e.target.value.length >= 3) {
                            setSearch(e.target.value);
                          } else if (e.target.value.length == 0) {
                            setSearch("");
                          }
                        }}
                      /> */}
                    <div className="w-full float-right">
                      <button
                        className="btn btn-default waves-effect"
                        onClick={callExport}
                      >
                        Export Sheet
                      </button>
                    </div>
                  </div>
                  <div>
                    <DataTable
                      onSort={onSort}
                      sortIcon={customSortIcon}
                      value={promoUsage}
                    >
                      {columns.map((col, i) => {
                        return (
                          <Column
                            key={col.name}
                            field={col.label}
                            header={col.name}
                            body={col.selector}
                            sortable={col.sortable}
                            style={{
                              width: col.width ? col.width : "200px",
                            }}
                          />
                        );
                      })}
                    </DataTable>
                    <Paginator
                      className="float-right"
                      first={first}
                      rows={perPage}
                      totalRecords={totalRows}
                      rowsPerPageOptions={[10, 15, 20, 25, 30]}
                      onPageChange={onPageChange}
                    ></Paginator>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
